import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import { 
  Bot, 
  Brain,
  ClipboardCheck,
  Clock,
  ChevronRight,
  Sparkles
} from 'lucide-react';
import '../styles/agents.css';

function Agents() {
  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAgents = async () => {
      try {
        const response = await axios.get('https://n8n.iniai.cloud/webhook/get-agents', {
          headers: {
            'x-api-key': 'auth_k_2f9a8b3c7d6e4f5g9h8i1j2k3l4m5n6',
            'Content-Type': 'application/json'
          },
          withCredentials: true
        });

        const sortedAgents = response.data.sort((a, b) => a['Agent ID'] - b['Agent ID']);
        setAgents(sortedAgents);
      } catch (err) {
        console.error('Error fetching agents:', err);
        setError('Failed to load agents');
      } finally {
        setLoading(false);
      }
    };

    fetchAgents();
  }, []);

  if (loading) return <div className="loading-state">Loading agents...</div>;
  if (error) return <div className="error-state">{error}</div>;

  return (
    <div className="agents-container">
      <h1>Agents</h1>
      <p className="agents-intro">
        Meet the team of AI agents ready to assist you:
      </p>

      <div className="agents-grid">
        {agents.map(agent => {
          if (!agent) return null;

          const status = (agent['Agent Status'] || 'Coming Soon').toLowerCase();
          const capabilities = Array.isArray(agent['Agent Capabilities']) 
            ? agent['Agent Capabilities'] 
            : [];
          
          return (
            <div key={agent.id} className={`agent-card ${status}`}>
              <div className="agent-icon">
                <Bot size={32} className="icon-primary" />
              </div>

              <div className="agent-header">
                <h2>
                  {agent['Agent Name']}
                  {status === 'coming soon' && (
                    <span className="status-badge">
                      <Clock size={14} />
                      Coming Soon
                    </span>
                  )}
                </h2>
              </div>

              {agent['Agent Role'] && (
                <div className="agent-role">
                  <Brain size={16} className="icon-secondary" />
                  {agent['Agent Role']}
                </div>
              )}
              
              {agent['Agent Description'] && (
                <p className="agent-description">
                  {agent['Agent Description']}
                </p>
              )}

              {capabilities.length > 0 && (
                <div className="agent-capabilities">
                  <h3>
                    <Sparkles size={16} className="icon-secondary" />
                    Capabilities
                  </h3>
                  <ul>
                    {capabilities.map((capability, index) => (
                      <li key={index}>
                        <ClipboardCheck size={14} className="icon-list" />
                        {capability}
                      </li>
                    ))}
                  </ul>
                </div>
              )}

              {status === 'active' && (
                <a 
                  href={`/agent/${agent['Agent Name'].toLowerCase()}`} 
                  className="agent-link"
                >
                  Work with {agent['Agent Name']}
                  <ChevronRight size={16} />
                </a>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Agents;